import createAction from 'Store/utils/createAction';
import { SEARCH_SET_KEYWORDS } from 'Store/constants';
export function setKeywords(keywords: string): SetKeywordsAction {
  return createAction(SEARCH_SET_KEYWORDS, {
    keywords,
  });
}
